// @flow

import type {
  User,
} from 'fc-model-users/types'

// Effect Manager
import { fork, put, select, take } from 'redux-saga/effects'

// Action Types
import { ADD_USER, EDIT_USERS, DELETE_USER, EDIT_BILLING_INFO } from '../constants'

// Selectors
import { users$ } from 'fc-users'
import datatable from '../datatable'
import { currentUser$ } from 'hfty-users'

// Operator
import usersOperator from 'fc-operator-user'
import billingInfoOperator from 'hfty-operator-billing-info'

// Constants
import { PROP_US_CUSTOMARY, PROP_USER_EMAIL, PROP_USER } from 'fc-model-users'

// Exports
export default function *watchUserOperations (): Generator<*, void, *> {
  while (true) {
    const { type } = yield take([ADD_USER, EDIT_USERS, DELETE_USER, EDIT_BILLING_INFO])

    if (type === ADD_USER) {
      yield fork(handleAddUser)
    } else if (type === DELETE_USER) {
      yield fork(handleDeleteUser)
    } else if (type === EDIT_USERS) {
      yield fork(handleEditUsers)
    } else {
      yield fork(handleEditBillingInfo)
    }
  }
}

export function *handleAddUser (): Generator<*, void, *> {
  const operation = usersOperator.create({
    model: {
      first: '',
      last: '',
      phone: '',
      email: '',
      units: PROP_US_CUSTOMARY,
    },
  })

  yield put(usersOperator.actionCreators.add(operation))
}

export function *handleEditUsers (): Generator<*, void, *> {
  const users: User = yield select(users$)
  const selectedIds: Array<number> = yield select(datatable.selectors.selectedRecordIds$)
  const operations = selectedIds.map(function (userId: number): * {
    const user: User = users[userId]

    return usersOperator.create({
      model: {
        ...user,
        [PROP_USER]: {
          ...user[PROP_USER],
          [PROP_USER_EMAIL]: user[PROP_USER_EMAIL],
        },
      },
    })
  })

  yield put(usersOperator.actionCreators.edit(...operations))
}

export function *handleDeleteUser (): Generator<*, void, *> {
  const users: User = yield select(users$)
  const selectedIds: Array<number> = yield select(datatable.selectors.selectedRecordIds$)
  const operations = selectedIds.map(function (userId: number): * {
    const user: User = users[userId]

    return usersOperator.create({
      model: {
        ...user,
        [PROP_USER]: {
          ...user[PROP_USER],
          [PROP_USER_EMAIL]: user[PROP_USER_EMAIL],
        },
      },
    })
  })

  yield put(usersOperator.actionCreators.delete(...operations))
}

export function *handleEditBillingInfo (): Generator<*, void, *> {
  const parentUser = yield select(currentUser$)

  const operations = billingInfoOperator.create({
    model: parentUser.clientBillingAddress,
  })

  yield put(billingInfoOperator.actionCreators.edit(operations))
}
